import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const inputClass =
  "w-full bg-ink border border-[rgba(176,132,51,0.3)] px-4 py-3 text-bone text-sm focus:outline-none focus:border-gold transition-colors";

export default function SecuritySection() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("La nuova password deve avere almeno 8 caratteri");
      return;
    }
    if (next !== confirm) {
      toast.error("Le nuove password non coincidono");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password aggiornata");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="admin-security-section" className="border border-[rgba(176,132,51,0.25)] p-6 mb-10">
      <h2 className="font-display text-xl tracking-[0.2em] text-gold mb-2">SICUREZZA</h2>
      <p className="text-bone/30 text-xs mb-6">
        Cambia la password di accesso all'area riservata. Minimo 8 caratteri.
      </p>
      <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <div>
          <label className="block text-bone/50 text-xs tracking-widest mb-2">PASSWORD ATTUALE</label>
          <input
            data-testid="current-password-input"
            type="password"
            required
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            className={inputClass}
          />
        </div>
        <div>
          <label className="block text-bone/50 text-xs tracking-widest mb-2">NUOVA PASSWORD</label>
          <input
            data-testid="new-password-input"
            type="password"
            required
            value={next}
            onChange={(e) => setNext(e.target.value)}
            className={inputClass}
          />
        </div>
        <div>
          <label className="block text-bone/50 text-xs tracking-widest mb-2">CONFERMA NUOVA PASSWORD</label>
          <input
            data-testid="confirm-password-input"
            type="password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className={inputClass}
          />
        </div>
        <div className="md:col-span-3">
          <button
            data-testid="change-password-button"
            type="submit"
            disabled={busy}
            className="inline-flex items-center gap-2 bg-gold text-ink px-5 py-2 text-sm font-display tracking-[0.15em] hover:bg-gold-dark transition-colors disabled:opacity-50"
          >
            <KeyRound size={16} /> {busy ? "AGGIORNAMENTO..." : "CAMBIA PASSWORD"}
          </button>
        </div>
      </form>
    </section>
  );
}
